import { useIntl } from "react-intl";

const MobileAppSupport = () => {
    const intl = useIntl();
    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.MobileAppSupport.header",
            defaultMessage: "Mobile app support"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.MobileAppSupport.body",
            defaultMessage:
                "Get notified instantly on breached SLAs and requests that are assigned, reported, watched, and mentioned with @."
        })
    };
    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default MobileAppSupport;
